import firebase from 'firebase/app';

export const firestoreConvertJSDate = (
  date?: Date | string | number | null
): firebase.firestore.Timestamp => {
  if (!date) date = new Date();
  if (!(date instanceof Date)) date = new Date(date);
  return firebase.firestore.Timestamp.fromDate(date);
};
